import * as React from 'react';
import {Breadcrumb, Button, Col, Input, Row} from "antd";
import { Link } from 'react-router-dom';

export default class NameFilter extends React.Component<{afterAction:any},{name:string}> {

    constructor(props) {
        super(props);
        this.state = {name:'',};
    }

    componentDidMount() {
     
    }


    filter(empty?:boolean){
        let filterData = {}
        if( empty ){
        }else{
            if(this.state.name){
                filterData['field.name']='contain:'+this.state.name;
            }            
        }
        this.props.afterAction(true,{filter:filterData});
    }

    reset(){
        this.filter(true);
    }

    render(){
        return <span> <br />
            <form onSubmit={(e)=>{this.filter(); e.preventDefault();}}>
            <Row gutter={10}>
                <Col>Filter: </Col>
                <Col>
                    <Input placeholder="Name " onChange={(e)=>this.setState({name: e.target.value})} />
                </Col>                
                <Col>
                    <Button type="primary" htmlType='submit'>Filter</Button>
                </Col>
            </Row>
            </form>
        </span>
    }
}